export var SITE_LEISURE = 'leisure';
export var SITE_BB = 'business-booker';